import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import {
  FetchProductInstancesForEntitlementQueryPpcQuery,
  FetchProductInstancesForEntitlementQueryPpcQueryVariables,
  LinkedEntitlementTypes,
  LinkedProductTypes,
  SearchLinkedEntitlementParams,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchProductInstancesForEntitlementQueryPPC } from '../../../queries/fetch-enterprise-instances-for-entitlement-ppc';

interface UseFetchUserHistoryForEntitlementPPCQueryVariables {
  entitlementId: string;
  entitlementType: LinkedEntitlementTypes | undefined;
  productType: LinkedProductTypes | undefined | null;
  transactionAccountId: string;
  searchLinkedEntitlementParams?: Partial<SearchLinkedEntitlementParams>;
}

export const useFetchProductInstanceForEntitlementPPCQuery = ({
  entitlementId,
  entitlementType,
  productType,
  transactionAccountId,
  searchLinkedEntitlementParams,
}: UseFetchUserHistoryForEntitlementPPCQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    FetchProductInstancesForEntitlementQueryPpcQuery,
    FetchProductInstancesForEntitlementQueryPpcQueryVariables
  >(fetchProductInstancesForEntitlementQueryPPC, {
    variables: {
      id: entitlementId,
      transactionAccountId,
      searchLinkedEntitlementParams: {
        entitlementId: entitlementId,
        currentEntitlementType: entitlementType,
        destinationEntitlementType: [LinkedEntitlementTypes.ENTERPRISE_INSTANCE],
        productType: productType,
        ...searchLinkedEntitlementParams,
      },
    },
    skip: !entitlementId,
    client: ansClient,
  });
};
